<template>
  <EditorPopover
    ref="popover"
    @cancel="cancelEditing">

    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-cutout">
          <i class="far fa-map-marker-plus"></i> Add Points
        </Tab>
      </template>

      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-cutout">
          <div class="row">
            <div class="col-6">
              <div class="row form-group">
                <label class="col-form-label col-4">Points</label>
                <div class="col-8">
                  <FormInputText type="number" v-model="pointCount" :min="1" />
                </div>
              </div>
            </div>
          </div>

          <EditorPopoverButtonList v-if="editingEnabled">
            <EditorPopoverButton title="Cancel" type="cancel" icon="fa-times" @click="cancelEditing" />
            <EditorPopoverButton title="Add Points" type="update" icon="fa-plus-circle" @click="addPoints" />
          </EditorPopoverButtonList>
        </TabPage>
      </template>
    </TabbedBox>

  </EditorPopover>
</template>


<script>
import _ from 'lodash'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorPopoverMixin from '@glass-designer/mixins/editorPopover'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import EditorTypes from '@glass-designer/types'
import MathsUtils from '@/utils/mathsUtils'

import EditorPopoverButtonList from '@glass-designer/components/popover/editorPopoverButtonList'
import EditorPopoverButton from '@glass-designer/components/popover/editorPopoverButton'

export default {
  name: 'EditorAddPointsToolPopover',
  mixins: [EditorPopoverMixin],
  components: {
    EditorPopover,
    EditorKeypad,
    EditorPopoverButtonList,
    EditorPopoverButton
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      actionButtons: [],
      title: '',
      pointCount: 1
    }
  },
  computed: {
  },
  watch: {
    pointCount: function(newVal) {
      this.debouncedUpdateTool()
    },
  },
  created() {
    this.debouncedUpdateTool = _.debounce(this._updateTool, 100)
  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      options = _.defaults(options, {
        actionButtons: [],
        title: ''
      })

      this.pointCount = parseInt(options.pointCount || 1)

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.applyCallback = options.applyCallback
      this.cancelCallback = options.cancelCallback
    },
    clearOptions() {
      this.callbackContext = null
      this.updateCallback = null
      this.applyCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    onShortcutKey(code) {
      switch(code) {
        case 'Escape':
          this.cancelEditing()
          break
      }
    },
    _updateTool() {
      this.updateTool({ apply: false })
    },
    addPoints() {
      this.updateTool({ apply: true })
    },
    updateTool(options = {}) {
      try {

        if(options.apply) {
          if(this.applyCallback) {
            this.applyCallback(this.callbackContext, {
              pointCount: this.parseToolNumber(this.pointCount),
              actionTag: options.actionTag
            })
            this.hide()
          }
        } else {
          if(this.updateCallback) {
            this.updateCallback(this.callbackContext, {
              pointCount: this.parseToolNumber(this.pointCount),
            })
          }
        }

      } catch(err) {
        console.error(err)
        //this.errorText = `${err.message}`
      }

    }
  }
}
</script>